export enum CfSystemType {
  NZSCED = 4601,
  SCUNQ = 4602
}
